import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function sdiOrCertifiedEmailRequiredValidator(otherControlName: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.parent) {
            return null;
        }

        const currentValue = String(control.value || '').trim();
        const otherValue = String(control.parent.get(otherControlName)?.value || '').trim();

        if (!currentValue && !otherValue) {
            return { sdiOrCertifiedEmailRequired: true };
        }

        return null;
    };
}